import React from 'react'

function TextArea({ itemKey, rows, name, formState, onChangeHandler, labelText, placeholder }) {
  const { value, maxCount, status, counter } = itemKey
  return (
    <div className='mt-1'>
      <label htmlFor={name} className='form-label'>
        {labelText}<span className="text-danger">*</span>
        <span className='fw-light text-muted'></span>
      </label>
      <textarea
        rows={rows ? rows : 3}
        className={`form-control ${status} pt-2`}
        id={name}
        name={name}
        placeholder={placeholder}
        value={value}
        disabled={formState !== 'idle'}
        onChange={onChangeHandler}
      />
      <div className='d-flex flex-column align-items-end'>
        <small className={value.length >= maxCount ? 'text-danger' : ''}>
          {counter} / {maxCount}
        </small>
      </div>
    </div>
  )
}

export default TextArea
